<template>
  <div class="my-2">
    <label>
      {{ label }}
    </label>
    <input
      v-model="currentText"
      class="form-control"
      type="text"
      @change="changePropertyValue(ruleProperty.description)"
    >
  </div>
</template>

<script>
import ruleMixin from '@/employees/components/Rule/utilities/mixins/ruleMixin'
import { RULE_PROPERTY } from '@/constants'
export default {
  name: 'RuleDescriptionTranslation',
  mixins: [ruleMixin],
  props: {
    reference: {
      required: true,
      type: String,
    },
    label: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    translationType: {
      required: true,
      type: String,
      validator: function (value) {
        // The value must match one of these strings
        return ['nl', 'en', 'all'].includes(value)
      },
    },
  },
  data () {
    return {
      ruleProperty: RULE_PROPERTY,
      currentText: '',
    }
  },
  mounted () {
    this.currentText = this.text
  },
  methods: {
    changePropertyValue (rulePropertyEnum) {
      this.rulePropertyValueChange(this.reference, `${rulePropertyEnum}.${this.translationType}`, this.currentText)
    },
  },
}
</script>
